import { format } from 'date-fns';

/**
 * Formats a UTC date string to local timezone for display
 * @param dateString - UTC date string from backend
 * @returns Formatted date string in local timezone
 */
export const formatUTCDate = (dateString: string): string => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const localDate = new Date(year, month, day);
  return format(localDate, 'MMM d, yyyy');
};

/**
 * Formats a UTC datetime string to local timezone for display
 * @param dateString - UTC datetime string from backend
 * @returns Formatted datetime string in local timezone
 */
export const formatUTCDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, 'MMM d, yyyy h:mm a');
};

/**
 * Formats a local date to yyyy-MM-dd format for sending to backend
 * @param date - Local date object
 * @returns Date string in yyyy-MM-dd format
 */
export const formatDateForBackend = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};

/**
 * Parses a yyyy-MM-dd date string to a local Date object for display
 * @param dateString - Date string in yyyy-MM-dd format
 * @returns Local Date object or null if invalid
 */
export const parseDateStringToLocal = (dateString: string): Date | null => {
  if (!dateString || typeof dateString !== 'string') return null;
  
  const parts = dateString.split('-');
  if (parts.length !== 3) return null;
  
  const [year, month, day] = parts.map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
  
  const date = new Date(year, month - 1, day);
  if (isNaN(date.getTime())) return null;
  
  return date;
};
